import { render, staticRenderFns } from "./AccountProfileSettingsRemoveAddress.vue?vue&type=template&id=8511c58e&"
import script from "./AccountProfileSettingsRemoveAddress.vue?vue&type=script&lang=js&"
export * from "./AccountProfileSettingsRemoveAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports